module.exports = __webpack_public_path__ + "img/kefu.2f26cdba.png";